/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste one numeric column per group to build a ridgeline plot (also called a joyplot) — stacked, slightly overlapping density curves. It is the ideal way to show how a distribution shifts across an ordered sequence such as months or categories.`)
};

const es_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una columna numérica por grupo para crear un gráfico de cordillera (también llamado joyplot) — curvas de densidad apiladas y ligeramente superpuestas. Es la forma ideal de mostrar cómo se desplaza una distribución a lo largo de una secuencia ordenada, como meses o categorías.`)
};

const de_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine numerische Spalte pro Gruppe ein, um ein Ridgeline-Diagramm (auch Joyplot genannt) zu erstellen — gestapelte, leicht überlappende Dichtekurven. Es ist die ideale Methode, um zu zeigen, wie sich eine Verteilung über eine geordnete Abfolge wie Monate oder Kategorien hinweg verschiebt.`)
};

const nl_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak één numerieke kolom per groep om een ridgeline plot te maken (ook wel joyplot genoemd) — gestapelde, licht overlappende dichtheidscurven. Het is de ideale manier om te tonen hoe een verdeling verschuift over een geordende reeks zoals maanden of categorieën.`)
};

const fr_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une colonne numérique par groupe pour créer un graphique en crêtes (aussi appelé joyplot) — des courbes de densité empilées se chevauchant légèrement. C'est le moyen idéal de montrer comment une distribution évolue sur une séquence ordonnée telle que des mois ou des catégories.`)
};

const it_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una colonna numerica per gruppo per creare un grafico ridgeline (chiamato anche joyplot) — curve di densità impilate e leggermente sovrapposte. È il modo ideale per mostrare come si sposta una distribuzione lungo una sequenza ordinata come mesi o categorie.`)
};

const pt_br2_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para criar um gráfico ridgeline (também chamado de joyplot) — curvas de densidade empilhadas, levemente sobrepostas. É a forma ideal de mostrar como uma distribuição muda ao longo de uma sequência ordenada, como meses ou categorias.`)
};

const pt_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna numérica por grupo para construir um gráfico ridgeline (também chamado joyplot) — curvas de densidade empilhadas, ligeiramente sobrepostas. É a forma ideal de mostrar como uma distribuição se altera ao longo de uma sequência ordenada, como meses ou categorias.`)
};

const ja_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列を貼り付けて、リッジラインプロット(ジョイプロットとも呼ばれます)を作成します — 少しずつ重なり合った密度曲線を積み重ねたものです。月やカテゴリなど、順序のあるグループ間で分布がどのように変化するかを示すのに最適な方法です。`)
};

const zh_ridge_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组粘贴一列数值数据即可生成山脊图（也称为 joyplot）——层叠、略微重叠的密度曲线。这是展示分布如何在有序序列（如月份或类别）之间变化的理想方式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_intro", locale)
	if (locale === "en") return en_ridge_intro(inputs)
	if (locale === "es") return es_ridge_intro(inputs)
	if (locale === "de") return de_ridge_intro(inputs)
	if (locale === "nl") return nl_ridge_intro(inputs)
	if (locale === "fr") return fr_ridge_intro(inputs)
	if (locale === "it") return it_ridge_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_intro(inputs)
	if (locale === "pt") return pt_ridge_intro(inputs)
	if (locale === "ja") return ja_ridge_intro(inputs)
	return zh_ridge_intro(inputs)
};